import { render, staticRenderFns } from "./MemberEnrollAttendanceReportPDF.vue?vue&type=template&id=674490d2"
import script from "./MemberEnrollAttendanceReportPDF.vue?vue&type=script&lang=js"
export * from "./MemberEnrollAttendanceReportPDF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports